import { useLocale } from "../lib/i18n.jsx";
import { useTheme } from "../lib/theme.jsx";
import Icon from "./Icon.jsx";

// O ícone mostra o tema que o clique VAI aplicar (lua no claro, sol no escuro) —
// é a convenção que as pessoas já esperam. O aria-label diz a ação, não o estado,
// pelo mesmo motivo.
export default function ThemeToggle() {
  const { isDark, toggle } = useTheme();
  const { t } = useLocale();
  const label = isDark ? t("themeLight") : t("themeDark");

  return (
    <button type="button" className="theme-toggle" onClick={toggle} title={label} aria-label={label}>
      <Icon name={isDark ? "sun" : "moon"} size={15} />
    </button>
  );
}
